import { AxiosInstance, AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { IDeleteObjectRef } from "./AlarmSubscriptionDetails";
import { Spacer } from "../../../../../components/Layout/Layout";
import PrimeModal from "../../../../../ui-lib/components/PrimeModal/PrimeModal";

const ARCSubscriptionDeleteModal = ({
  isOpen,
  deleteData,
  isLoading,
  setDeleteModalOpen,
  loadData,
  removeHandler,
}: {
  isOpen: boolean;
  deleteData: React.MutableRefObject<IDeleteObjectRef | null>;
  isLoading: boolean;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loadData: () => Promise<void>;
  removeHandler: (
    apiFunc: (
      authenticatedRequest: AxiosInstance,
      rcId: number,
      subscriptionId: number,
      removeId: number,
    ) => Promise<AxiosResponse<any>>,
    id: number,
  ) => Promise<void>;
}) => {
  const { t } = useTranslation();
  const { apiFunc, id, type } = deleteData.current!;

  return (
    <PrimeModal
      withFooter
      withHeader
      header={t("AlarmReceptions:delete_from_subscriptions").replace(
        "{type}",
        t(`Common:${type}`).toLocaleLowerCase(),
      )}
      isOpen={isOpen}
      loading={isLoading}
      onClose={async () => {
        await loadData();
        setDeleteModalOpen(false);
      }}
      submitBtn={{
        text: `${t("Common:delete")} ${t(
          `Common:${type}`,
        ).toLocaleLowerCase()}`,
        onClick: async () => {
          await removeHandler(apiFunc, id);
          setDeleteModalOpen(false);
        },
        variant: "destructive",
      }}
      cancelBtn={{ text: "Cancel", onClick: () => setDeleteModalOpen(false) }}
      fixedWidth="576px"
    >
      <Spacer size={16} />
      <p>
        {t("Common:delete_modal_confirm").replace(
          "{type}",
          t(`Common:${type}`).toLocaleLowerCase(),
        )}
      </p>
    </PrimeModal>
  );
};

export default ARCSubscriptionDeleteModal;
